import React, { useRef } from 'react'

import {
  Button, Close, Icon, Search, TextInput,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object, string } from 'prop-types'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

function FilterSearchInput({
  id,
  value,
  onChange,
  placeholder,
  ariaLabel = null,
  inputRef = null,
  className = '',
}) {
  const translate = useTranslate()
  const ownInputRef = useRef(null)
  const fieldRef = inputRef || ownInputRef

  const handleChange = (event) => onChange(event.target.value)
  // The button unmounts once the value is empty, so focus goes back to the input instead of <body>.
  const handleClear = () => {
    onChange('')
    fieldRef.current?.focus()
  }
  const wrapperClassName = ['filter-wrapper__search', className].filter(Boolean).join(' ')

  return (
    <TextInput
      id={id}
      isPilot
      isSquishable
      size="medium"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      aria-label={ariaLabel}
      leadIcon={(
        <Icon
          notSpaced
          svgComponent={Search}
          size="small"
          color="darker"
          className="filter-wrapper__search-icon"
        />
      )}
      beforeTrailButton={value !== '' ? (
        <Button
          type="ghost"
          size="tiny"
          variant="only-icon"
          actionType="button"
          aria-label={translate('search_page.filters.clear_search')}
          icon={(
            // Figma uses #686C70, similar to the `dark` Icon color ($cgt-color-grey-60); please confirm with designers
            <Icon
              notSpaced
              svgComponent={Close}
              size="small"
              color="dark"
              className="filter-wrapper__clear-icon"
            />
          )}
          onClick={handleClear}
          customClass="filter-wrapper__clear-button"
        />
      ) : null}
      textInputClassName="filter-wrapper__search-input"
      wrapperClassName={wrapperClassName}
      innerRef={fieldRef}
    />
  )
}

FilterSearchInput.propTypes = {
  id: string.isRequired,
  value: string.isRequired,
  onChange: func.isRequired,
  placeholder: string.isRequired,
  ariaLabel: string,
  inputRef: object,
  className: string,
}

export default FilterSearchInput
